/** Base path for Access System voucher management (list, /new, /:voucherId). */
export const VOUCHERS_MANAGEMENT_BASE_PATH =
  "/customer/dsok/access-system/vouchers-management";
